import {Button, Col, Space, Typography, Row, Steps} from "antd";
import {useState} from "react";
import {useUpload} from "../context/Upload";
import DestinationStep from "../common/upload-steps/DestinationStep";
import UploadStep from "../common/upload-steps/UploadStep";
import {useNavigate} from "react-router-dom";
const { Text } = Typography;

const {Step} = Steps;

const STEPS_LENGTH = 2;

const UploadForm = () => {
    const [current, setCurrent] = useState(0);
    const navigate = useNavigate();
    const {status} = useUpload()

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const isDisabled = () => {
        return !(status.dataType && status.destination)
    }

    return (
        <Row>
            <Col span={20} offset={2}>
                <br/>
                <Text style={{ fontSize: 14 }} mark>
                    Upload can take up to 5 minutes.<br/>
                    The system can only process one file at a time.<br/><br/>
                    Be sure your .csv file matches the ARB Template<br/>
                    You can download the report templates here:<br/>
                    - <a href="https://ww2.arb.ca.gov/our-work/programs/advanced-clean-trucks/manufacturer-reporting">https://ww2.arb.ca.gov/our-work/programs/advanced-clean-trucks/manufacturer-reporting</a><br />
                    <strong>Note:</strong> If you get an unknown error, <strong>please ensure your headers exactly match the template headers.</strong><br />
                    If you are uncertain, copy and paste your data into a fresh copy of the template and try again after refreshing this page.
                    <br/>
                    If you can't figure it out, email support:<br/>
                    <a href = "mailto: ACTReporting@arb.ca.gov">ACTReporting@arb.ca.gov</a>
                </Text>
                <br/>
                <Steps type="navigation" current={current}>
                    <Step key={1} title={'Data Type & Destination'}/>
                    <Step key={2} title={'Upload'}/>
                </Steps>
                <Row justify="center" align="middle" style={{marginTop: "2em"}}>
                    <Col span={24}>
                        {current === 0 ? <DestinationStep/> : <UploadStep/>}
                    </Col>
                </Row>
                <div style={{marginTop: "1.5em"}}>
                    {current < STEPS_LENGTH - 1 && (
                        <Button type="primary" disabled={isDisabled()}
                                onClick={() => next()}>
                            Next
                        </Button>
                    )}
                    {current === STEPS_LENGTH - 1 && (
                        <Button type="primary" disabled={!status.done} onClick={() => navigate("/", {replace: true})}>
                            Done
                        </Button>
                    )}
                    {current > 0 && (
                        <Button style={{margin: '0 8px'}} onClick={() => prev()}>
                            Previous
                        </Button>
                    )}
                </div>
            </Col>
        </Row>
    )
}

export default UploadForm;
